import { useContext, useState } from "react";
import { AuthContext } from "context/AuthContext";

import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { BiError } from "react-icons/bi";
import { Label, TextInput, Button, Alert, Checkbox } from "flowbite-react";

import "./styles.scss";

interface IFormInput {
  username: string;
  password: string;
  rememberMe: boolean;
}

export function Login() {
  const navigate = useNavigate();

  const { register, handleSubmit } = useForm<IFormInput>();
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useContext(AuthContext);

  function handleSignIn(data: IFormInput) {
    setLoading(true);
    doLogin(data.username, data.password);
  }

  function handleSignInError(error: any) {
    console.error(error);
  }

  async function doLogin(username: string, password: string) {
    try {
      setErrorMessage("");
      await login({ username, password });
    } catch (error: any) {
      setLoading(false);
      setErrorMessage(error.message);
    }
  }

  return (
    <div
      id="login-wrapper"
      className="w-full min-h-screen flex items-center justify-center"
    >
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo"></div>
        </div>

        <form
          className="login-form"
          onSubmit={handleSubmit(handleSignIn, handleSignInError)}
        >
          <div className="form-group">
            <Label htmlFor="username" className="form-label">Email</Label>
            <TextInput
              {...register("username")}
              id="username"
              name="username"
              type="email"
              autoComplete="email"
              placeholder="perfil123@email.com"
              required
              className="form-input"
              onKeyUp={() => setErrorMessage("")}
            />
          </div>

          <div className="form-group">
            <Label htmlFor="password" className="form-label">Senha</Label>
            <TextInput
              {...register("password")}
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              required
              placeholder="••••••••"
              className="form-input"
              onKeyUp={() => setErrorMessage("")}
            />
          </div>

          <div className="form-options">
            <div className="flex items-center gap-2">
              <Checkbox
                {...register("rememberMe")}
                id="rememberMe"
                name="rememberMe"
              />
              <Label htmlFor="rememberMe" className="remember-label">
                Lembrar-me
              </Label>
            </div>
            <Link
              to="/forgot-password"
              className="forgot-password-link"
            >
              Esqueceu a senha?
            </Link>
          </div>

          {!!errorMessage && (
            <Alert color="failure" icon={BiError}>
              {errorMessage}
            </Alert>
          )}

          <Button
            type="submit"
            disabled={loading}
            className="login-button"
          >
            {loading ? "Aguarde..." : "Entrar"}
          </Button>
        </form>
      </div>
    </div>
  );
}
